import { TeacherSlidePage } from "@/pages/teacher/TeacherSlidePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/books/lessons/$lessonId/slides/$slideId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { lessonId, slideId } = Route.useParams();
  return <TeacherSlidePage lessonId={lessonId} slideId={slideId} />;
}
